"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Details_1 = __importDefault(require("./Details"));
/**
 * A collection of course details
 * @param {number} count the number of course details returned
 * @param {string} lastKey the pagination key for the last item
 * @param {Array.<CourseDetail>} courses the course details
 */
class CourseDetails extends Details_1.default {
    constructor(fields) {
        super(fields, 'courses');
    }
}
exports.default = CourseDetails;
//# sourceMappingURL=CourseDetails.js.map